/** Emails compare case-insensitively and without surrounding whitespace. */
export const normalizeEmail = (email: string) => email.trim().toLowerCase()

/** Account names compare ignoring case, punctuation and repeated spaces: "The  Pub." matches "the pub". */
export const normalizeName = (name: string) =>
  name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()

export const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('')
